import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter);

//push 
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
	return VueRouterPush.call(this, to).catch(err => err)
}

const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(to) {
	return VueRouterReplace.call(this, to).catch(err => err)
}

// 前台用户系统路由
const foreRouter = [{
	path: '/home',
	name: 'Home',
	component: () => import('@/views/foreground/home.vue')
}, {
	path: '/register',
	name: 'Register',
	component: () => import('@/views/foreground/user/register.vue')
}, {
	path: '/login',
	name: 'Login',
	component: () => import('@/views/foreground/user/login.vue')
}, {
	path: '/mailverification',
	name: 'Mailverification',
	component: () => import('@/views/foreground/user/mailverification.vue')
},

{
	// 查询基因序列
	path: '/searchGeneSequence',
	name: 'GeneSequence',
	component: () => import('@/views/foreground/sequenceRetrieval/geneSequence.vue')
}, {
	// 列表
	path: '/queryHistory',
	name: 'QueryHistory',
	component: () => import('@/views/foreground/sequenceRetrieval/list.vue')
}, {
	// 详情
	path: '/detail',
	name: 'Detail',
	component: () => import('@/views/foreground/sequenceRetrieval/detail.vue')
}]

import {
	menus
} from "@/constant/data.js"
// 后台管理路由
const manageRouter = [
	...menus,
]

const router = new VueRouter({
	routes: [{
		path: '/',
		redirect: '/index'
	}, {
		path: '/index',
		name: 'Index',
		redirect: '/home',
		component: () => import('@/views/index.vue'),
		children: [
			// 前台用户系统
			{
				path: '/fore',
				name: 'Fore',
				redirect: '/home',
				component: () => import('@/views/foreground/index.vue'),
				children: [
					...foreRouter
				]
			},
			// 后台管理
			{
				path: '/manage',
				name: 'Manage',
				component: () => import('@/views/manage/index.vue'),
				redirect: '/manageHome',
				children: [
					{
						path: '/manageLogin',
						name: 'ManageLogin',
						component: () => import('@/views/manage/login.vue')
					},
					{
						path: '/manageHome',
						name: 'ManageHome',
						redirect: '/userManage',
						component: () => import('@/views/manage/pages/home.vue'),
						children: [
							...manageRouter
						]
					}
				]
			}
		]
	}, {
		path: '/404',
		component: () => import('@/views/404.vue')
	// }, {
	// 	path: '*',
	// 	redirect: '/404'
	}]
})

// 路由跳转前
router.beforeEach((to, from, next) => {
	// 可用于拦截导航并执行一些操作，例如验证用户身份、权限控制等。
	to.meta.title && (document.title = to.meta.title);
	next()
})

// 路由跳转后
router.afterEach((to, from) => {
	window.scrollTo(0, 0) // 每次路由改变滚动条都回到顶部
})

export default router